import React, { useState } from 'react';
import { Modal } from './Modal';
export function Footer() {
  const [isPrivacyPolicyOpen, setIsPrivacyPolicyOpen] = useState(false);
  return <footer className="py-6 border-t border-orange-800/30 mt-10" data-id="element-98">
      <div className="container mx-auto text-center" data-id="element-99">
        <p className="text-orange-300/70 text-sm" data-id="element-100">
          © {new Date().getFullYear()} TrueMarketer. All rights reserved.
        </p>
        <div className="mt-2" data-id="element-101">
          <button onClick={() => setIsPrivacyPolicyOpen(true)} className="text-sm text-orange-300/70 hover:text-orange-300 transition-colors" data-id="element-102">
            Privacy Policy
          </button>
        </div>
        <Modal isOpen={isPrivacyPolicyOpen} onClose={() => setIsPrivacyPolicyOpen(false)} title="Privacy Policy" data-id="element-103">
          <div className="text-left max-h-[70vh] overflow-y-auto pr-2" data-id="element-104">
            <p className="mb-4" data-id="element-105">
              Last Updated: {new Date().toLocaleDateString()}
            </p>
            <h3 className="text-lg font-bold mb-2" data-id="element-106">1. Introduction</h3>
            <p className="mb-4" data-id="element-107">
              TrueMarketer ("we," "our," or "us") respects your privacy and is
              committed to protecting your personal information. This Privacy
              Policy explains how we collect, use, disclose, and safeguard your
              information when you use our services.
            </p>
            <h3 className="text-lg font-bold mb-2" data-id="element-108">
              2. Information We Collect
            </h3>
            <p className="mb-4" data-id="element-109">
              We may collect personal information that you voluntarily provide
              when using our services, including but not limited to your name,
              email address, phone number, and business information. We may also
              automatically collect certain information about your device and
              usage patterns.
            </p>
            <h3 className="text-lg font-bold mb-2" data-id="element-110">
              3. How We Use Your Information
            </h3>
            <p className="mb-4" data-id="element-111">
              We use the information we collect to provide, maintain, and
              improve our services, communicate with you, and comply with legal
              obligations. This includes sending you marketing communications,
              providing customer support, and analyzing usage patterns to
              enhance user experience.
            </p>
            <h3 className="text-lg font-bold mb-2" data-id="element-112">
              4. Cookies and Tracking Technologies
            </h3>
            <p className="mb-4" data-id="element-113">
              We use cookies and similar tracking technologies to track activity
              on our website and hold certain information. You can instruct your
              browser to refuse all cookies or to indicate when a cookie is
              being sent.
            </p>
            <h3 className="text-lg font-bold mb-2" data-id="element-114">
              5. Data Sharing and Disclosure
            </h3>
            <p className="mb-4" data-id="element-115">
              We do not sell your personal information. We may share your
              information with service providers who help us deliver our
              services, when required by law, or in connection with a business
              transaction.
            </p>
            <h3 className="text-lg font-bold mb-2" data-id="element-116">6. Data Security</h3>
            <p className="mb-4" data-id="element-117">
              We implement appropriate security measures to protect your
              personal information. However, no method of transmission over the
              Internet or electronic storage is 100% secure.
            </p>
            <h3 className="text-lg font-bold mb-2" data-id="element-118">7. Your Rights</h3>
            <p className="mb-4" data-id="element-119">
              Depending on your location, you may have certain rights regarding
              your personal information, such as the right to access, correct,
              or delete your data.
            </p>
            <h3 className="text-lg font-bold mb-2" data-id="element-120">
              8. Changes to This Policy
            </h3>
            <p className="mb-4" data-id="element-121">
              We may update our Privacy Policy from time to time. We will notify
              you of any changes by posting the new Privacy Policy on this page.
            </p>
            <h3 className="text-lg font-bold mb-2" data-id="element-122">9. Contact Us</h3>
            <p className="mb-4" data-id="element-123">
              If you have any questions about this Privacy Policy, please
              contact us at:{' '}
              <a href="mailto:support@truemarketer.com" className="text-orange-400 hover:underline" data-id="element-124">
                support@truemarketer.com
              </a>
            </p>
          </div>
        </Modal>
      </div>
    </footer>;
}